'use client'

import { AnimatedGradientButton } from '@/app/[locale]/[roomId]/components/AnimatedGradientButton'
import IconLock from '@/components/assets/icon_lock.svg'
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext'
import { useUAContext } from '@/context/UAContext'
import { useMobileWorldRedirectUrlBuilder } from '@/hooks/useMobileWorldRedirectUrl'
import { useTranslations } from 'next-intl'
import { useIsClient } from 'usehooks-ts'

const gradientPresets = {
  play: [
    {
      background: 'linear-gradient(270deg, #7B74FF 0%, #00A0CB 53.38%, #00A0CB 100%)',
      color: 'rgba(255,255,255,0.4)',
    },
    {
      background: 'linear-gradient(270deg, #05ECE1 0%, #00A0CB 50.47%, #7B74FF 100%)',
      color: 'rgba(255,255,255,1)',
    },
  ],
  premium: [
    {
      background: 'linear-gradient(270deg, #FF82FB 0%, #00A0CB 58.81%, #00A0CB 100%)',
      color: 'rgba(255,255,255,0.4)',
    },
    {
      background: 'linear-gradient(270deg, #05ECE1 0%, #00B3E3 38.45%, #FF82FB 100%)',
      color: 'rgba(255,255,255,1)',
    },
  ],
}

export default function WorldPlayButtonMobile() {
  const t = useTranslations()
  const isClient = useIsClient()
  const { isMobile, isMobileApp } = useUAContext()
  const { isPreferredDevice, isVoucherCheckPassed, roomData } = useCheckEnterRoomContext()
  const getRedirectUrl = useMobileWorldRedirectUrlBuilder()
  const communityUserId = roomData.owner.community_user_id

  if (
    !isPreferredDevice ||
    !isMobile ||
    !isClient ||
    (isVoucherCheckPassed === false && isMobileApp)
  )
    return null

  return isVoucherCheckPassed === false ? (
    <AnimatedGradientButton
      icon={<IconLock className="size-6 fill-white" />}
      label={t('world-info.get-premium')}
      linkTo={`/profile/${communityUserId}?premium=true`}
      gradients={gradientPresets.premium}
    />
  ) : (
    <AnimatedGradientButton
      biKey="world_mobile_play"
      label={t('world-info.play')}
      linkTo={getRedirectUrl({ isFull3d: true })}
      gradients={gradientPresets.play}
    />
  )
}
